import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Menu } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      marginTop: theme.spacing(1)
    }
  };
});

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      _ref$anchorEl = _ref.anchorEl,
      anchorEl = _ref$anchorEl === void 0 ? null : _ref$anchorEl,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      dsOnClose = _ref.dsOnClose,
      e2e = _ref.e2e;
  var classes = useStyles();
  var anchorOrigin = React.useRef({
    vertical: 'bottom',
    horizontal: 'left'
  });
  var transformOrigin = React.useRef({
    vertical: 'top',
    horizontal: 'left'
  });

  if (!anchorEl) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Menu, _extends({
    anchorEl: anchorEl,
    className: classes.root
  }, e2e && {
    'data-e2e': e2e
  }, {
    anchorOrigin: anchorOrigin.current,
    transformOrigin: transformOrigin.current,
    getContentAnchorEl: null,
    open: open,
    onClose: dsOnClose
  }), children);
};

export default Dropdown;

try {
  Dropdown.__docgenInfo = {
    description: '',
    displayName: 'Dropdown',
    methods: [],
    props: {
      a11yId: {
        defaultValue: null,
        description: 'Needed for accessibility. On the button invoking this dropdown,\n' + "set 'aria-controls' equal to this id.",
        name: 'a11yId',
        required: true,
        type: {
          name: 'string'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      dsOnClose: {
        defaultValue: null,
        description: '',
        name: 'dsOnClose',
        required: true,
        type: {
          name: '(event: {}, reason: "backdropClick" | "escapeKeyDown") => void'
        }
      },
      open: {
        defaultValue: {
          value: false
        },
        description: 'If `true`, the menu is visible.',
        name: 'open',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      anchorEl: {
        defaultValue: {
          value: null
        },
        description: 'A HTML element, or a function that returns it.\n' + "It's used to set the position of the menu.\n" + '@document',
        name: 'anchorEl',
        required: false,
        type: {
          name: 'Element | ((element: Element) => Element)'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map